module.exports = __webpack_public_path__ + "img/app_slide_stats.ca7e5757.png";